const themeColors = Object.freeze({
    black: {
        palette: {
            type: "light",
            primary: {
                main: "#2474b2"
            },
            secondary: {
                main: "#b9c4dE"
            },
            complementary: {
                primary: "#01d1c0",
                secondary: "#9d67FF"
            },
            corporatives: {
                airbnb: "#ff385c"
            },
            background: {
                default: "#F2F7FF",
                paper: "#FFF"
            },
            text: {
                primary: "#2B3643",
                secondary: "#999",
                hint: "#eee"
            },
            success: {
                main: "#35BA84",
                light: "#66CAA2"
            },
            error: {
                main: "#E76061",
                light: "#EC8687"
            },
            graphics: [
                "#A3CBE8",
                "#B0E0E6",
                "#9AD3DE",
                "#A0E7E5",
                "#C3B1E1",
                "#D2B9E3",
                "#A7E4C2",
                "#A7D3D0",
                "#D7BDE2",
                "#B9DFF1",
                "#A1E3D8",
                "#A6BCE0",
                "#C9C0E7",
                "#A5B8D9",
                "#8FB4D0",
                "#ABCDEF",
                "#ADD8E6",
                "#C1B2E3",
                "#C8A2C8",
                "#8FD3C7" 
            ],
            tags: {
                bgColor: ['#80DB8F', '#FFE45E', '#12A3B9', '#E0FF4F', '#00D1C0', '#F79F79', '#2474B2'],
                textColor: ['#FFF', '#000']
            }
        }
    }
})

export default themeColors